module.exports = __webpack_public_path__ + "static/media/BackIcon.67872278.svg";